import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, NavigationExtras, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {
  constructor(
    public router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let token = localStorage.getItem('remote_token');
    let is_login = localStorage.getItem('is_login');
    if (token) {
      return true;
    } else {
      if(is_login) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            url: state.url,
          },
        }

        this.router.navigate(['/login'], navigationExtras);
        return false;
      }

      if (this.hasBeforeLoginNotifications()) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            url: state.url,
          },
        };
        this.router.navigate(['/login/notifications'], navigationExtras);
      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            dynamic: 1,
          }
        };
        this.router.navigate(['/login'], navigationExtras);
      }
      return false;
    }
  }

  private hasBeforeLoginNotifications(): boolean {
    if (localStorage.getItem('portal_settings')) {
      let settings = JSON.parse(localStorage.getItem('portal_settings'));
      if (settings?.additional_settings?.before_login?.before_login_allow_multistep === "yes" || settings?.additional_settings?.custom_notifications?.before_login) {
        return true;
      }
    }
    return false;
  }

}
